import { useLayoutEffect, useRef } from 'react'

const useStateRef = <T extends any>(value: T) => {
  const ref = useRef(value)

  useLayoutEffect(() => {
    ref.current = value
  }, [value])

  return ref
}

export default useStateRef
